/**
 * Vue 应用入口
 *
 * 初始化:
 * - PWA 单实例检查（仅 PWA 独立窗口模式）
 * - Vue 应用实例
 * - Pinia 状态管理
 * - Vue Router 路由
 * - i18n 国际化
 * - Element Plus UI 框架
 */
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import App from './App.vue'
import router from './router'
import i18n from './i18n'
import './styles/main.scss'
import { registerPwa } from './pwa/register'
import { initSingleInstance } from './pwa/single-instance'
import SingleInstanceBlock from './components/SingleInstanceBlock.vue'

/**
 * 初始化应用
 */
async function initApp() {
  // 检查是否已有 PWA 实例运行（仅在 PWA 独立窗口模式下检查）
  const canContinue = await initSingleInstance()

  if (!canContinue) {
    // 已有 PWA 实例，显示阻止界面让用户选择
    const blockApp = createApp(SingleInstanceBlock)
    blockApp.use(i18n)
    blockApp.mount('#app')
    return
  }

  // 没有其他 PWA 实例，或者在浏览器模式下，正常启动应用
  const app = createApp(App)

  // 注册所有 Element Plus 图标
  for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
  }

  app.use(createPinia())
  app.use(router)
  app.use(i18n)
  app.use(ElementPlus)

  router.isReady().then(() => {
    app.mount('#app')
    registerPwa()
  })
}

// 启动应用
initApp().catch(error => {
  console.error('[App] Failed to initialize:', error)
})
